import { render, staticRenderFns } from "./asidebar.vue?vue&type=template&id=403518e6&scoped=true&lang=pug&"
import script from "./asidebar.vue?vue&type=script&lang=js&"
export * from "./asidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403518e6",
  null
  
)

export default component.exports